import { defineStore } from 'pinia';
import { fetchSiteProfile, type SiteSocialAccount } from '@/features/support/site-profile-api';

let inflight: Promise<void> | null = null;

/** 站点公开资料（在线客服链接等）：全局只拉一次，失败可重试。 */
export const useSiteProfileStore = defineStore('siteProfile', {
  actions: {
    async load(force = false) {
      if (this.loaded && !force) return;
      if (inflight) return inflight;
      inflight = fetchSiteProfile()
        .then((profile) => {
          this.supportUrl = profile.supportUrl?.trim() || '';
          this.telegramUrl = profile.telegramUrl?.trim() || '';
          this.socialAccounts = Array.isArray(profile.socialAccounts) ? profile.socialAccounts : [];
          this.registerPointsEnabled = Boolean(profile.registerPointsEnabled)
            && (profile.registerPointsMinor ?? 0) > 0;
          this.registerPointsMinor = this.registerPointsEnabled
            ? Number(profile.registerPointsMinor) || 0
            : 0;
          this.loaded = true;
        })
        .catch(() => {
          // 失败保持未加载，下次点击再拉；不阻塞壳层渲染
        })
        .finally(() => {
          inflight = null;
        });
      return inflight;
    },
  },
  getters: {
    hasSupport: (state) => state.supportUrl !== '',
    hasTelegram: (state) => state.telegramUrl !== '',
    showRegisterGift: (state) => state.registerPointsEnabled && state.registerPointsMinor > 0,
  },
  state: () => ({
    loaded: false,
    registerPointsEnabled: false,
    registerPointsMinor: 0,
    socialAccounts: [] as SiteSocialAccount[],
    supportUrl: '',
    telegramUrl: '',
  }),
});
